import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
function TaskFormHeader({
  edit,
  isRepeating = false
}) {
  if (edit && isRepeating) {
    return /*#__PURE__*/_jsx(Text, {
      as: "h3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "taskFormsLib.header.editRepeatingTaskTitle"
      })
    });
  } else if (edit) {
    return /*#__PURE__*/_jsx(Text, {
      as: "h3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "taskFormsLib.header.editTaskTitle"
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "h3",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "taskFormsLib.header.createTaskTitle"
    })
  });
}
export default TaskFormHeader;